module.exports = __webpack_public_path__ + "img/image-map-2-62385dd5.png";